<template>
    <v-card @click="goToPage" :style="[toPage ? {'cursor': 'pointer', 'border-radius': '8px'} : {'border-radius': '8px'}]">
      <v-card-title>
        <div class="layout column ma-0 justify-space-between pb-1">
          <div class="rectangle-5" :style="{ backgroundColor: color }"></div>
          <div class="title">{{title}}</div>
          <p v-if="description" class="description">{{ description }}</p>

        </div>
      </v-card-title>
      <v-container fluid>
    <v-layout row wrap align-center style="background-color: #F1F1F1; margin: 15px; border-radius: 15px;">
        <v-flex xs6>
            <v-subheader>Campanha</v-subheader>
        </v-flex>
        <v-flex xs2>
            <v-subheader>Cliques</v-subheader>
        </v-flex>
        <v-flex xs2>
            <v-subheader>Conversões</v-subheader>
        </v-flex>
        <v-flex xs2>
            <v-subheader>Comissões</v-subheader>
        </v-flex>
    </v-layout>
    <v-layout row wrap align-center style="margin: 15px; border-radius: 15px; border: 1px solid #F1F1F1;">
        <table>
            <tbody>
                <tr>
                    <td>{ campanha }</td>
                    <td>{ cliques }</td>
                    <td>{ conversoes }</td>
                    <td>{ comissoes }</td>
                </tr>
            </tbody>
        </table>
    </v-layout>
    <v-layout row wrap align-center>
        <v-flex xs12>
            <div class="text-xs-right" style="padding-right: 10px;">
                    <v-btn round to="/campaigns" color="#C89D2F" style="color: #fff;">Ver Campanhas</v-btn>
            </div>
        </v-flex>
    </v-layout>
  </v-container>
    </v-card>
  </template>

<script>
    export default {
        data () {
      return {
        options: {
        chart: {
          id: 'vuechart-example'
        },
        xaxis: {
          categories: ['01/04/2023', '04/04/2023', '07/04/2023', '10/04/2023', '13/04/2023', '16/04/2023', '18/04/2023', '21/04/2023']
        },
        colors: ['#f7464a', '#297ec4']
      },
      series: [{
        name: 'Cliques',
        data: [30, 40, 45, 50, 49, 60, 70, 91]
      },
      {
        name: 'Conversões',
        data: [20, 28, 35, 30, 39, 46, 60, 71]
      }],
        select: { state: 'Todas Ofertas', abbr: 'TD' },
        items: [
          { state: 'SIAPE', abbr: 'FL' },
          { state: 'Cosignado', abbr: 'GA' },
          { state: 'Cartão Will', abbr: 'NE' },
          { state: 'Cartão INSS', abbr: 'CA' },
          { state: 'Pré-digitação SIAPE', abbr: 'NY' }
        ]
      }
    },
        props: {
            icon: String,
            title: String,
            total: Number,
            cancelledAmount: Number,
            reachedAmount: Number,
            lines: Array,
            caption: String,
            color: String,
            description: String,
            linearStatistic: {
                type: Boolean,
                default: true
            },
            todayBalance: {
                type: Number,
                default: 0
            },
            toPage: String
        },

        methods: {
            goToPage() {
                if (this.toPage) {
                    this.$router.push(this.toPage);
                }
            },

            getPercent(value) {
                let p = 0;
                if (value > 0) {
                    p = value / this.total;
                }

                return p;
            },
        },
   };
</script>

<style scoped>
   .corner {
      margin-top: -7px !important;
      margin-right: -7px !important;
      height: 60px;
      width: 95px;
      float: right;
   }

   .description {
      font-size: 15px;
      margin-top: 5px;
      color: #555;
   }

   .rectangle-5 {
        background-color: green;
        border-radius: 0px 30px 30px 0px;
        height: 78px;
        width: 9px;
        margin-left: -16px;
    }

    .title {
        padding-left: 10px;
        margin-top: -70px;
    }

    .headline {
        padding-left: 10px;
    }

    .subheadline {
        padding-left: 10px;
        color: #656565;
        font-weight: 500;
        left: 1px;
        letter-spacing: 0;
    }

    h3 {
        color: black;
        font-weight: 600; 
        font-size: xx-large !important;
    }

    .hero-statics {
        /* background-color: #F1F1F1; */
        min-width: 180px; 
        border-radius: 15px;
        margin-right: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/CampaignsCard.vue